// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    oauth: `${ROOTS.AUTH}/oauth-link`,
    logout: `${ROOTS.AUTH}/logout`,
  }, // DASHBOARD
  dashboard: {
    root: `${ROOTS.DASHBOARD}`,
    overview: `${ROOTS.DASHBOARD}/overview`,
    networth: `${ROOTS.DASHBOARD}/networth`,
    income: `${ROOTS.DASHBOARD}/income`,
    expenses: `${ROOTS.DASHBOARD}/expenses`,
    cashflow: `${ROOTS.DASHBOARD}/cashflow`,
    assets: `${ROOTS.DASHBOARD}/assets`,
    liabilities: `${ROOTS.DASHBOARD}/liabilities`,
    transactions: `${ROOTS.DASHBOARD}/transactions`,
    // REPORTS
    reports: `${ROOTS.DASHBOARD}/reports`,
    budget: `${ROOTS.DASHBOARD}/reports/budget`,
    actual: `${ROOTS.DASHBOARD}/reports/actual`,
    budgetVsActual: `${ROOTS.DASHBOARD}/reports/budget-vs-actual`,
    forecast: `${ROOTS.DASHBOARD}/reports/forecast`,
    // SETTINGS
    settings: `${ROOTS.DASHBOARD}/settings`,
    scenarios: `${ROOTS.DASHBOARD}/settings/scenarios`,
    accounts: `${ROOTS.DASHBOARD}/settings/accounts`,
    contact: `${ROOTS.DASHBOARD}/settings/contact`,
    profile: `${ROOTS.DASHBOARD}/settings/profile`,
  },
};
